

export default () => {

    $(document).on('click', '.post-widget__block .menu-item-has-children', function () {
        $(this).toggleClass('active');
    });
}
  
